import { render, staticRenderFns } from "./CourseDayCrudSubmit.vue?vue&type=template&id=98c26e8a&lang=pug&"
import script from "./CourseDayCrudSubmit.vue?vue&type=script&lang=js&"
export * from "./CourseDayCrudSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports